import {
    useGridApiContext,
} from '@mui/x-data-grid-pro'

const useClearSorting = () => {
    const apiRef = useGridApiContext()

    return () => {
        apiRef.current.setSortModel([])
    }
}

export default useClearSorting
